import { localizedRouteGroup } from 'routing/routes';

export const importedListingRoute = localizedRouteGroup.route(
  'imported-action-opps/:source/:volopId',
);
